import { FeatureLaunch, isFeatureLaunched } from '@commenda/feature-launches';

export const isOwnershipOverhaulOn = (companyId: number): boolean =>
  isFeatureLaunched(FeatureLaunch.OWNERSHIP_OVERHAUL, companyId);
